import React, { useState } from 'react'
import { ProductTabWapper } from './Styled';
import { Box, SpanStyled } from '../../../../ui/Elements';
import { useTranslation } from 'react-i18next';

const ProductsTab = ({ fillter, menuList }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (category) => {
        setActiveTab(category);
        fillter(category);
    };
    return (
        <ProductTabWapper>
            <Box className='tabWrapperProduct'>
                {
                    menuList.map((data, key) => {
                        return (
                            <Box key={key} className={`TabButtonWrapper ${activeTab === data ? 'active' : ''}`} onClick={() => handleTabClick(data)} >
                                <SpanStyled >
                                    {t(data)}
                                </SpanStyled>
                            </Box>
                        );
                    })}
            </Box>
        </ProductTabWapper>
    )
}

export default ProductsTab

